import { AllowArrayInCompanyId } from "Util/allowArrayInCompanyId"
import BaseService from "./_base.service"
import { StorageBox } from "Models/storage.box"
import { AxiosResponse } from "axios"
import API from "../api";

const endpoint = "/storage-boxes/despatch"

const DispatchStorageBoxService = {
  ...BaseService<AllowArrayInCompanyId<StorageBox>, StorageBox>({ endpoint }),

  async list(options?: any): Promise<AxiosResponse<StorageBox[]>> {
    return await API.get(`${endpoint}/list`, { params: options });
  },

  async countList(options?: any): Promise<AxiosResponse<StorageBox[]>> {
    return await API.get(`${endpoint}/count`, { params: options });
  },
}

export default DispatchStorageBoxService;
